// extracted by mini-css-extract-plugin
export default {"pdfPage":"pdf-viewer_pdfPage__GOwCO"};